var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDontNetCore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 260,
    viewBox: "0 0 260 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_22_16)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 36,
    width: 180,
    height: 180,
    rx: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 36.5,
    width: 179,
    height: 179,
    rx: 31.5,
    stroke: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.5 176C156.838 176 179 153.614 179 126C179 98.3858 156.838 76 129.5 76C102.162 76 80 98.3858 80 126C80 153.614 102.162 176 129.5 176Z",
    fill: "#5C2D91"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M95.1904 90.0625C90.1583 94.5919 86.095 100.112 83.2496 106.283C80.4041 112.455 78.8365 119.149 78.6427 125.954C78.4489 132.759 79.633 139.533 82.1225 145.86C84.612 152.186 88.3545 157.933 93.1204 162.747C97.8864 167.561 103.575 171.341 109.839 173.856C116.102 176.371 122.808 177.567 129.546 177.371C136.283 177.175 142.91 175.592 149.02 172.718C155.13 169.843 160.594 165.739 165.078 160.656L95.1904 90.0625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4469 134.203C91.1582 134.208 90.8716 134.152 90.6054 134.039C90.3391 133.926 90.0989 133.758 89.9 133.547C89.6957 133.343 89.5342 133.099 89.4252 132.831C89.3162 132.562 89.262 132.275 89.2658 131.984C89.2637 131.694 89.3188 131.407 89.4276 131.139C89.5365 130.871 89.6971 130.627 89.9 130.422C90.097 130.207 90.3364 130.036 90.6029 129.92C90.8693 129.804 91.1569 129.746 91.4469 129.75C91.7365 129.749 92.0232 129.809 92.2892 129.924C92.5553 130.04 92.7951 130.209 92.9938 130.422C93.2002 130.625 93.3641 130.868 93.4757 131.136C93.5873 131.405 93.6444 131.693 93.6435 131.984C93.6462 132.276 93.5899 132.565 93.4782 132.833C93.3665 133.102 93.2017 133.345 92.9938 133.547C92.7932 133.756 92.5527 133.922 92.2868 134.035C92.021 134.148 91.7353 134.205 91.4469 134.203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.183 133.812H118.13L103.636 111.094C103.275 110.534 102.974 109.937 102.739 109.312H102.615C102.753 110.61 102.805 111.915 102.77 113.219V133.812H99.4751V105.328H103.76L117.867 127.641C118.455 128.568 118.837 129.203 119.012 129.547H119.089C118.926 128.157 118.859 126.758 118.888 125.359V105.328H122.183V133.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.489 133.812H129.5V105.328H143.793V108.344H132.872V117.812H143.051V120.812H132.872V130.687H144.505L144.489 133.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.625 108.344H158.427V133.812H155.132V108.344H147.026V105.328H166.625V108.344Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.404 153.188C119.288 153.734 118.056 153.997 116.816 153.953C115.992 153.991 115.169 153.85 114.403 153.54C113.638 153.23 112.947 152.758 112.376 152.156C111.24 150.871 110.641 149.191 110.705 147.469C110.664 146.536 110.808 145.605 111.13 144.73C111.451 143.855 111.943 143.054 112.577 142.375C113.195 141.736 113.937 141.234 114.758 140.9C115.578 140.566 116.458 140.409 117.342 140.438C118.399 140.401 119.453 140.587 120.435 140.984V142.547C119.489 142.018 118.423 141.749 117.342 141.766C116.66 141.746 115.982 141.876 115.355 142.145C114.727 142.415 114.165 142.819 113.706 143.328C112.742 144.438 112.242 145.884 112.314 147.359C112.242 148.757 112.708 150.129 113.614 151.188C114.048 151.66 114.579 152.031 115.169 152.276C115.759 152.522 116.395 152.635 117.032 152.609C118.22 152.641 119.393 152.338 120.42 151.734L120.404 153.188Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.731 153.953C126.115 153.973 125.502 153.86 124.934 153.62C124.366 153.38 123.855 153.019 123.436 152.562C122.59 151.609 122.151 150.357 122.214 149.078C122.176 148.408 122.269 147.737 122.49 147.104C122.71 146.471 123.053 145.889 123.498 145.391C123.953 144.943 124.493 144.594 125.086 144.365C125.68 144.137 126.313 144.034 126.948 144.062C127.547 144.03 128.147 144.129 128.705 144.353C129.263 144.577 129.766 144.92 130.181 145.359C131.003 146.36 131.417 147.639 131.341 148.937C131.406 150.255 130.956 151.546 130.088 152.531C129.661 152.997 129.141 153.365 128.562 153.61C127.983 153.855 127.359 153.972 126.731 153.953ZM126.839 145.406C126.414 145.388 125.99 145.467 125.599 145.638C125.208 145.808 124.86 146.066 124.581 146.391C123.986 147.165 123.689 148.131 123.746 149.109C123.692 150.059 123.989 150.995 124.581 151.734C124.863 152.055 125.211 152.308 125.602 152.476C125.993 152.643 126.415 152.721 126.839 152.703C127.254 152.728 127.67 152.656 128.053 152.494C128.437 152.331 128.778 152.082 129.051 151.766C129.614 150.989 129.888 150.038 129.825 149.078C129.886 148.114 129.612 147.158 129.051 146.375C128.782 146.052 128.442 145.796 128.058 145.628C127.674 145.46 127.257 145.384 126.839 145.406Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.565 145.875C138.231 145.654 137.834 145.55 137.435 145.578C137.124 145.59 136.82 145.678 136.55 145.836C136.28 145.994 136.053 146.217 135.889 146.484C135.428 147.221 135.207 148.084 135.254 148.953V153.734H133.708V144.359H135.254V146.312C135.424 145.708 135.763 145.166 136.229 144.75C136.632 144.396 137.149 144.202 137.683 144.203C137.982 144.19 138.281 144.232 138.565 144.328V145.875Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.629 149.438H141.086C141.042 150.311 141.324 151.169 141.875 151.844C142.162 152.133 142.506 152.357 142.884 152.502C143.263 152.648 143.667 152.711 144.072 152.688C145.12 152.677 146.134 152.308 146.949 151.641V153.047C145.992 153.684 144.86 153.996 143.716 153.938C143.139 153.967 142.562 153.867 142.027 153.646C141.493 153.424 141.013 153.087 140.622 152.656C139.817 151.642 139.414 150.361 139.493 149.063C139.437 147.761 139.874 146.488 140.715 145.5C141.097 145.054 141.574 144.699 142.109 144.461C142.644 144.223 143.224 144.108 143.809 144.125C144.336 144.095 144.864 144.186 145.351 144.392C145.839 144.598 146.274 144.913 146.624 145.313C147.336 146.261 147.687 147.437 147.614 148.625L147.629 149.438ZM146.083 148.172C146.114 147.448 145.895 146.735 145.464 146.156C145.252 145.915 144.989 145.725 144.694 145.6C144.4 145.476 144.081 145.42 143.762 145.438C143.429 145.433 143.099 145.499 142.793 145.631C142.487 145.763 142.211 145.958 141.983 146.203C141.474 146.747 141.154 147.444 141.071 148.188L146.083 148.172Z",
    fill: "#F2F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_22_16",
    x: 0,
    y: 0,
    width: 260,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0367917 0 0 0 0 0.0348958 0 0 0 0 0.0484375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22_16"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_22_16",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 99,
    height: 100,
    fill: "white",
    transform: "translate(80 76)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDontNetCore);
export default __webpack_public_path__ + "static/media/dont-net-core.a618fc02797a414ca4fd44256e0b0489.svg";
export { ForwardRef as ReactComponent };